import React, { useRef } from 'react';
import { useLiquidField } from '../../hooks/useLiquidField';

const MASK_SRC = `${process.env.PUBLIC_URL}/omnistrix-transparent.png`;

const Hero = () => {
  const canvasRef = useRef(null);
  useLiquidField(canvasRef, { maskSrc: MASK_SRC });

  return (
    <section className="hero">
      <canvas className="hero-canvas" ref={canvasRef} aria-hidden="true" />
      <div className="hero-content">
        <h1>You talk to the people writing the code.</h1>
        <div className="hero-side">
          <p>
            Omnistrix is a software house. We design, build and run web platforms and
            mobile apps, and we answer for the architecture, the security and the cloud bill.
          </p>
          <div className="hero-actions">
            <a href="#contact" className="btn">Book a 30-minute consult</a>
            <a href="#portfolio" className="text-link">See the work</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
